import type React from "react";
import { Reveal } from "@/components/motion/motion";
import { cn } from "@/lib/utils";

/** Mono overline with the accent dash: `— 01  Services`. */
export function Overline({
	children,
	index,
	className,
}: {
	children: React.ReactNode;
	index?: string;
	className?: string;
}) {
	return (
		<p
			className={cn(
				"flex items-center gap-3 font-mono text-[11px] font-medium tracking-[0.08em] text-muted-foreground uppercase",
				className,
			)}
		>
			<span aria-hidden="true" className="text-signal-ink">
				{"//"}
			</span>
			{index ? <span className="text-signal-ink">{index}</span> : null}
			<span>{children}</span>
		</p>
	);
}

export const displayH2 =
	"text-[clamp(1.75rem,3.3vw,2.75rem)] leading-[1.08] font-semibold tracking-[-0.05em] text-balance";

/**
 * Editorial section heading: left-aligned title, description pushed to the
 * right column on large screens.
 */
export function SectionHeading({
	label,
	title,
	description,
	index,
	className,
}: {
	label: string;
	title: string;
	description?: string;
	index?: string;
	className?: string;
}) {
	return (
		<Reveal
			className={cn(
				"grid gap-6 lg:grid-cols-[minmax(0,1.25fr)_minmax(0,1fr)] lg:items-end lg:gap-16",
				className,
			)}
		>
			<div className="space-y-5">
				<Overline index={index}>{label}</Overline>
				<h2 className={displayH2}>{title}</h2>
			</div>
			{description ? (
				<p className="max-w-xl text-lg text-pretty text-muted-foreground lg:pb-1.5">
					{description}
				</p>
			) : null}
		</Reveal>
	);
}
